import permissions from '../permission-list'

export default [
  {
    path: '/v2/vouchers',
    name: 'vouchers-v2',
    component: () => import('@/views/v2/Vouchers.vue'),
    meta: {
      pageTitle: 'Voucher',
      resource: permissions.voucherV2,
      action: 'read',
      navActiveLink: 'vouchers-v2',
      breadcrumb: [
        { text: 'Voucher', active: true },
      ],
    },
  },
  {
    path: '/v2/vouchers/create',
    name: 'vouchers-v2-create',
    component: () => import('@/views/v2/VoucherCreate.vue'),
    meta: {
      pageTitle: 'Buat Voucher',
      resource: permissions.voucherV2,
      action: 'manage',
      navActiveLink: 'vouchers-v2',
      breadcrumb: [
        { text: 'Voucher', to: { name: 'vouchers-v2' } },
        { text: 'Buat', active: true },
      ],
    },
  },
  {
    path: '/v2/vouchers/:id/detail',
    name: 'vouchers-v2-detail',
    component: () => import('@/views/v2/VoucherDetail.vue'),
    meta: {
      pageTitle: 'Detail Voucher',
      resource: permissions.voucherV2,
      action: 'read',
      navActiveLink: 'vouchers-v2',
      breadcrumb: [
        { text: 'Voucher', to: { name: 'vouchers-v2' } },
        { text: 'Detail', active: true },
      ],
    },
  },
  {
    path: '/v2/vouchers/:id/edit',
    name: 'vouchers-v2-edit',
    component: () => import('@/views/v2/VoucherEdit.vue'),
    meta: {
      pageTitle: 'Edit Voucher',
      resource: permissions.voucherV2,
      action: 'manage',
      navActiveLink: 'vouchers-v2',
      breadcrumb: [
        { text: 'Voucher', to: { name: 'vouchers-v2' } },
        { text: 'Edit', active: true },
      ],
    },
  },
]
